import { render, staticRenderFns } from "./MarketSettingPenalty.component.vue?vue&type=template&id=6f7bb51e&scoped=true"
import script from "./MarketSettingPenalty.component.vue?vue&type=script&lang=js"
export * from "./MarketSettingPenalty.component.vue?vue&type=script&lang=js"
import style0 from "./MarketSettingPenalty.component.vue?vue&type=style&index=0&id=6f7bb51e&prod&lang=scss&scoped=true"
import style1 from "./MarketSettingPenalty.component.vue?vue&type=style&index=1&id=6f7bb51e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7bb51e",
  null
  
)

export default component.exports